/**
 * Images served from the assets host rather than bundled with the app.
 *
 * Every `.svg` import in this app is compiled into the JS bundle by @svgr, so a `.svg` that is really a
 * wrapper around a base64 bitmap ships as JavaScript on every page that imports it. These assets are
 * bitmaps, so they live on the assets host instead: the browser caches them separately from the bundle,
 * and the host negotiates WebP for browsers that accept it.
 *
 * Each is stored at 4x its display size, except the Google wordmark: its only source is a 119x36 bitmap,
 * so it ships at those pixels rather than being upscaled. Filenames carry no `@Nx` suffix; the comment on each
 * constant gives the display size. Set `width` and `height` on the `img` so
 * layout does not shift while the image loads.
 */

/** Row of booking-site logos in the accommodation visibility confirmation dialog. Displays at 73x23. */
export const HOTELS_ICON_IMAGE = 'https://withjoy.com/assets/public/firstpartyhotels/compare/hotels-icon.png';

/** Booking.com mark shown in the guest-side price comparison. Displays at 24x24. */
export const BOOKING_SMALL_ICON_IMAGE = 'https://withjoy.com/assets/public/firstpartyhotels/compare/booking-small-icon.png';

/** Google wordmark for the "Powered by Google" attribution on place search. Displays at 60x19. */
export const GOOGLE_WORD_LOGO_IMAGE = 'https://withjoy.com/assets/public/apps/shared/google-word-logo.png';

/** "Get it on Google Play" store badge. Displays at 132px or 170px wide. */
export const GOOGLE_PLAY_BUTTON_IMAGE = 'https://withjoy.com/assets/public/apps/shared/google-play-button.png';

/** Vrbo wordmark on the guest-side "search vacation rentals" button. Displays at 71x36. */
export const VRBO_LOGO_IMAGE = 'https://withjoy.com/assets/public/firstpartyhotels/compare/vrbo.png';
